import { Redirect, Route, useLocation } from 'react-router-dom';
import api from 'api/client';
import React, { useEffect } from 'react';

const PublicRoute = ({ component: Component, ...rest }) => {
  const token = api.getToken();
  const location = useLocation();

  useEffect(() => {
    const sipData = new URLSearchParams(location.search).get('sipdata');
    const manualSipData = new URLSearchParams(location.search).get(
      'manualSipData'
    );
    if (sipData !== null) {
      try {
        const decodedSipData = decodeURIComponent(sipData);

        // Now, you can parse the decoded string into a JavaScript object
        const sipState = JSON.parse(decodedSipData);

        // Do something with sipState if needed
        localStorage.setItem('sipdata', decodedSipData);
      } catch (error) {
        console.error('Error decoding or parsing sipdata:', error);
      }
    } else if (manualSipData !== null) {
      try {
        const decodedmanualSipData = decodeURIComponent(manualSipData);

        // Now, you can parse the decoded string into a JavaScript object

        // Do something with sipState if needed
        localStorage.setItem('manualSipData', decodedmanualSipData);
      } catch (error) {
        console.error('Error decoding or parsing sipdata:', error);
      }
    }
    if (manualSipData !== null) {
      try {
        // const decodedSipData = decodeURIComponent(manualSipData);
        // Now, you can parse the decoded string into a JavaScript object
        // const sipState = JSON.parse(decodedSipData);

        // Do something with sipState if needed
        localStorage.setItem('manualSipData', manualSipData);
      } catch (error) {
        console.error('Error decoding or parsing sipdata:', error);
      }
    }
  }, [location.search]);
  return (
    <Route
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...rest}
      render={(props) =>
        token ? <Redirect to='/dashboard' /> : <Component {...props} />
      }
    />
  );
};

export default PublicRoute;
